<template>
  <v-container
    class="payout-items-view-container"
    fluid
  >
    <h1>Payout Items</h1>
    <payout-items-table
      :payout-items="payoutItems"
      :payout-items-pagination="payoutItemsPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { PayoutItemsTable } from '@/components/baader';

export default {
  name: 'PayoutItems',
  components: {
    'payout-items-table': PayoutItemsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.payoutItemsStore.loading,
      payoutItems: state => state.payoutItemsStore.payoutItems,
      payoutItemsPagination: state => state.payoutItemsStore.payoutItemsPagination,
    }),
  },
  async mounted() {
    this.getPayoutItems(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getPayoutItems']),
  },
};
</script>


<style lang="scss" scoped>
.payout-items-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/PayoutItems.vue